import { lazy, Suspense, useEffect, useRef, useState } from "react";

import {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    BrowserRouter as Router,
    Link,
    useNavigate
} from "react-router-dom";

import {
    Navbar,
    Container,
    Nav,
    NavDropdown,
    Carousel
} from "react-bootstrap";

import "./PublicHeader.css";

import { GetCurrentRoute } from "../../../../hooks/pageUtils/GetCurrentRoute";
import { LayoutsService } from "../../../../services/layout/layouts.service";
import { AssetsService } from "../../../../services/data/assets.service";
import { globalUriLoader } from "../../../../services/singletons/generic/global.uri.loader";
import { LayoutContainerModel } from "../../../../models/containers/layout/LayoutContainerModel";
import { useIsMobile } from "../../../../hooks/pageUtils/UseIsMobile";

const FullRawFrameNews = lazy(() =>
    import("../../news/FullRawFrameNews")
        .then(module => ({ default: module.FullRawFrameNews }))
);

const BannerFullRawFrameNews = lazy(() =>
    import("../../news/BannerFullRawFrameNews")
        .then(module => ({ default: module.BannerFullRawFrameNews }))
);


export default function PublicHeader() {
    const initialized = useRef(false);
    const isMobile = useIsMobile();
    const navigate = useNavigate();
    const selfNavbar = useRef<HTMLDivElement>(null);
    const bannerVideoSpacer = useRef<HTMLDivElement>(null);

    const [expanded, setExpanded] = useState(false);

    const layoutsService = useRef(new LayoutsService());
    const assetsService = useRef(new AssetsService());

    const [blogListModels, setBlogListModels] = useState<Array<LayoutContainerModel>>([]);
    const [diBlasiNaMidiaModels, setDiBlasiNaMidiaModels] = useState<Array<LayoutContainerModel>>([]);

    const [ route, setRoute ] = useState<string>("");
    const [ showBannerVideo, setShowBannerVideo ] = useState<boolean>(false); 

    const [imageBannerModels, setImageBannerModels] = useState<LayoutContainerModel[]>([]);
    
    const [bannerSrc, setBannerSrc] = useState<string | null>(null);
    const [pageBannerModel, setPageBannerModel] = useState<LayoutContainerModel | undefined>(undefined);
    const [imageBannerModel, setImageBannerModel] = useState<LayoutContainerModel | undefined>(undefined);
    const [logoDiblasiSecondarySrc, setLogoDiblasiSecondarySrc] = useState<string | undefined>(undefined);

    const [currentBannerId, setCurrentBannerId] = useState<number>(0);
    
    useEffect(() => {
        if (!initialized.current) {
            initialized.current = true;

            const fetchLayoutAssets = async () => {
                setLogoDiblasiSecondarySrc(await globalUriLoader.getDependentAssetUri("layout-logo-di-blasi-secundaria"));
            };

            const fetchMenuContent = async () => {
                let containers = await layoutsService.current.handleListLayoutContainersWithRange(
                    1,
                    100,
                    undefined,
                    undefined,
                    "categoria-ativo-blog-menu",
                    8,
                    true
                );

                if (containers) {
                    for (const container of containers) {
                        setBlogListModels(prev => [...prev, container]);
                    }

                    containers = undefined;
                }

                containers = await layoutsService.current.handleListLayoutContainersWithRange(
                    1,
                    100,
                    undefined,
                    undefined,
                    "categoria-ativo-di-blasi-na-midia-menu",
                    9,
                    true
                );

                if (containers) {
                    for (const container of containers) {
                        setDiBlasiNaMidiaModels(prev => [...prev, container]);
                    }
                    
                    containers.length = 0;
                }
            };
            
            fetchLayoutAssets();
            fetchMenuContent();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (!initialized.current) {
            return;
        }
        let cancelled = false;

        const loadBannerSrc = async () => {
            setExpanded(false);
            
            if (route === "/" || route.startsWith("/home")) {
                setShowBannerVideo(true);
                if (cancelled) return;

                setPageBannerModel(undefined);

                const tempImageBannerModels: LayoutContainerModel[] | undefined =
                    await layoutsService.current.handleListLayoutContainersWithRange(
                        1,
                        5,
                        undefined,
                        undefined,
                        "page-news-banner",
                        1,
                        true,
                        true
                    );
                
                if (tempImageBannerModels?.length) {
                    setImageBannerModels(tempImageBannerModels);
        
                } else {
                    const fallbackContainer = await layoutsService.current.handleGetLayoutContainer(
                        1,
                        undefined,
                        "page-banner",
                        1,
                        true
                    );
                    setBannerSrc(
                        fallbackContainer?.content
                            ? assetsService.current.getDependentAssetUri(fallbackContainer.content)
                            : null
                    );
                }
                return;
            }
            
            if (route.startsWith("/categoria/geral")) {
                setShowBannerVideo(true);
                if (cancelled) return;

                let container: LayoutContainerModel | undefined =
                    await layoutsService.current.handleGetLayoutContainer(
                        undefined,
                        undefined,
                        "categoria-page-blog-news",
                        8,
                        true
                    );

                // Only proceed if we received a valid object
                if (container && typeof container === 'object') {
                    container.content = assetsService.current.getDependentAssetUri(container.content);
                    setPageBannerModel(container);
                }
                return;
            }
            
            setShowBannerVideo(false);
            setBannerSrc(null);
        };

        loadBannerSrc();

        return () => {
            cancelled = true;
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [route]);

    useEffect(() => {
        setImageBannerModel(imageBannerModels[currentBannerId]);

    }, [currentBannerId, imageBannerModels]);

    const handleNavToggle = (isOpen: boolean) => {
        setExpanded(!expanded);

        if (bannerVideoSpacer.current !== null) {
            bannerVideoSpacer.current!.style.display = isOpen ? "none" : "block";
        }
    };
    
    /*useEffect(() => {
        if (selfNavbar.current) {
            const navbarHeight = selfNavbar.current.offsetHeight;
            document.body.style.paddingTop = `${navbarHeight}px`;
        }
    }, [selfNavbar.current?.offsetHeight]);*/
    
    return (
        <>
            <GetCurrentRoute setRoute={setRoute}/>
            <div className='top-header'>
                <Carousel
                    className='small'
                    style={{
                        minWidth: "400px", 
                        width: "33%", 
                        justifySelf: "center"
                    }}
                    prevIcon={
                        <span
                            className="carousel-control-prev-icon"
                            style={{
                                width: "1rem",
                                height: "1rem",
                                backgroundSize: "100% 100%",
                            }}
                        />
                    }
                    nextIcon={
                        <span
                            className="carousel-control-next-icon"
                            style={{
                                width: "1rem",
                                height: "1rem",
                                backgroundSize: "100% 100%",
                            }}
                        />
                    }>
                    <Carousel.Item>
                        <div className='text-light-top-header'>
                            A queridinha dos famosos
                        </div>
                    </Carousel.Item>
                    <Carousel.Item>
                        <div className='text-light-top-header'>
                            Contrate nosso Buffet (Apenas RJ)
                        </div>
                    </Carousel.Item>
                    <Carousel.Item>
                        <div className='text-light-top-header'>
                            Seja um Franqueado
                        </div>
                    </Carousel.Item>
                    <Carousel.Item>
                        <div className='text-light-top-header'>
                            Estamos em todo o Brasil
                        </div>
                    </Carousel.Item>
                    <Carousel.Item>
                        <div className='text-light-top-header'>
                            Promoção para cada dia da semana
                        </div>
                    </Carousel.Item>
                    <Carousel.Item>
                        <div className='text-light-top-header'>
                            Estamos em PE, PA, PB, SP, ES, SC e RJ
                        </div>
                    </Carousel.Item>
                </Carousel>
            </div>
            <Navbar
                ref={selfNavbar}
                className={showBannerVideo ? 'bg-primary custom' : 'bg-primary'}
                expanded={expanded}
                onToggle={handleNavToggle}
                expand="lg"
                /*style={{
                    paddingInline: "5%",
                    position: "fixed", 
                    top: 0,          
                    left: 0,    
                    width: "100%",    
                    zIndex: "1000"
                }}*/
                style={{
                    paddingInline: "5%"
                }}
            >
                <Container fluid>
                    <Navbar.Brand>
                        {
                            logoDiblasiSecondarySrc &&
                            <button 
                                onClick={() => navigate("/")}
                                style={{
                                    backgroundColor: "transparent",
                                    border: "none",
                                    boxShadow: "none"
                                }}
                            >
                                <img 
                                    src={logoDiblasiSecondarySrc}
                                    alt='logo'
                                    width="100%"
                                    height="100vh">
                                </img>
                            </button>
                        }
                    </Navbar.Brand>
                    <Navbar.Toggle aria-controls="navbar-nav-dropdown"/>
                    <Navbar.Collapse 
                        id="navbar-nav-dropdown"
                        style={{width: "100%"}}
                    >
                        <Nav>
                            <a 
                                className="nav-link link-secondary" 
                                onClick={(e) => {e.preventDefault(); navigate("/#sobrediblasi");}}
                                href="/#"
                            >
                                Sobre Nós
                            </a>
                            <a 
                                className="nav-link link-secondary" 
                                onClick={(e) => {e.preventDefault(); navigate("/nossas-unidades/brasil");}}
                                href="/#"
                            >
                                Nossas Unidades
                            </a>
                            <a 
                                className="nav-link link-secondary" 
                                onClick={(e) => {e.preventDefault(); navigate("/escolha-sua-pizza");}}
                                href="/#"
                            >
                                Sabores
                            </a>
                            <a 
                                className="nav-link link-secondary" 
                                onClick={(e) => {e.preventDefault(); navigate("/contato");}}
                                href="/#"
                            >
                                Contato
                            </a>
                            
                            <NavDropdown 
                                title={<span className="link-secondary">DI Blasi na Mídia</span>} 
                                id="nav-dropdown" 
                                style={{marginInline: "0"}}
                            >
                                {diBlasiNaMidiaModels.map((model, i) => (
                                    <NavDropdown.Item
                                        key={i}
                                        as={Link} to={"di-blasi-na-midia/" + model.tag.split("categoria-ativo-di-blasi-na-midia-menu-")[1]}
                                    >
                                        {model.name}
                                    </NavDropdown.Item>
                                ))}
                                <NavDropdown.Item 
                                    onClick={() => navigate("/#famosos")}
                                >
                                    O que Dizem os Famosos
                                </NavDropdown.Item>
                            </NavDropdown>

                            <NavDropdown 
                                title={<span className="link-secondary">Blog</span>} 
                                id="nav-dropdown"
                                style={{marginInline: "0"}}
                            >
                                {blogListModels.map((model, i) => (
                                    <NavDropdown.Item
                                        key={i}
                                        as={Link} to={"categoria/" + model.tag.split("categoria-ativo-blog-menu-")[1]}
                                    >
                                        {model.name}
                                    </NavDropdown.Item>
                                ))}
                            </NavDropdown>
                        </Nav>
                        <Nav 
                            style={{
                                display: "flex", 
                                marginLeft: "auto", 
                                alignSelf: "start"
                            }}>
                            <NavDropdown title={<span className="link-secondary">Área do Franqueado</span>} id="nav-dropdown">
                                <NavDropdown.Item
                                    as={Link} to="/franquia?shownav=true"
                                >
                                    Seja um Franqueado
                                </NavDropdown.Item>
                                <NavDropdown.Item 
                                    href='https://diblasipizzas.sults.com.br/login'
                                >
                                    Entrar
                                </NavDropdown.Item>
                            </NavDropdown>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
            {
                showBannerVideo && !pageBannerModel && bannerSrc && !expanded &&
                <>
                    <video 
                        className="banner-video"
                        loop
                        autoPlay
                        muted
                        playsInline
                    >
                        <source key={bannerSrc ?? "empty"} src={bannerSrc ?? undefined} type="video/webm"/>
                    </video>
                    <div 
                        className="div-video-spacer"
                        ref={bannerVideoSpacer}
                    /> 
                </>
            }
            {
                showBannerVideo && imageBannerModel && !pageBannerModel && !expanded &&
                <>
                    <div 
                        className="banner-video"
                        key={imageBannerModel.id ?? currentBannerId}
                    >
                        <Suspense fallback={null}>
                            <BannerFullRawFrameNews model={imageBannerModel}/>
                        </Suspense>
                    </div>
                    <div
                        className="div-video-spacer"
                        ref={bannerVideoSpacer}
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: isMobile ? "flex-start" : "flex-center"
                        }}
                    >
                        <button
                            className="news-nav-button"
                            onClick={() => {
                                if (currentBannerId === 0) {
                                    setCurrentBannerId(imageBannerModels.length -1);
                                }
                                else{
                                    setCurrentBannerId(prevCount => prevCount - 1)
                                }
                            }}
                            style={{
                                backgroundColor: "transparent",
                                border:"none",
                                boxShadow: "none",
                                marginLeft: "30px",
                                marginRight: "15px",
                                fontSize: isMobile ? "72px" : "86px"
                            }}
                        >
                            ⟨
                        </button>
                        <button
                            onClick={() => navigate(imageBannerModel.additionalContent)}
                            style={{
                                border: "none",
                                backgroundColor: "transparent",
                                boxShadow: "none",
                                width: "100%",
                                height: "100%"
                            }}
                        >
                        </button>
                        <button
                            className="news-nav-button"
                            onClick={() => {
                                if (currentBannerId === imageBannerModels.length -1) {
                                    setCurrentBannerId(0);
                                }
                                else{
                                    setCurrentBannerId(prevCount => prevCount + 1)
                                }
                            }}
                            style={{
                                backgroundColor: "transparent",
                                border:"none",
                                boxShadow: "none",
                                marginRight: "30px",
                                marginLeft: "15px",
                                fontSize: isMobile ? "72px" : "86px"
                            }}
                        >
                            ⟩
                        </button>
                    </div> 
                </>
            }
            {
                pageBannerModel && showBannerVideo && !expanded &&
                <>
                    <div className="banner-video" style={{paddingTop: "45px"}}>
                        <Suspense fallback={null}>
                            <FullRawFrameNews model={pageBannerModel} />
                        </Suspense>
                    </div>
                    <div 
                        className="div-video-spacer"
                        ref={bannerVideoSpacer}
                    />
                </>
            }
        </>
    );
}